import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const uploadCopDocument = api(async function uploadCopDocument({ codeOfPracticeId, name, fileName, fileData }) {
    return mutate(
        gql`
            mutation UploadCopDocument($codeOfPracticeId: ID!, $name: String!, $fileName: String!, $fileData: String!) {
                uploadCopDocument(
                    codeOfPracticeId: $codeOfPracticeId
                    name: $name
                    fileName: $fileName
                    fileData: $fileData
                )
            }
        `,
        { codeOfPracticeId, name, fileName, fileData },
        { returns: "uploadCopDocument" }
    )
})
